import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { processOAuthCallback } from '@/services/api';

export default function MetaCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        // Fluxo com hash: backend redireciona para /connect/meta/callback#success=true&access_token=...
        // Ignora o hash "_=_" que o Facebook adiciona automaticamente em redirects OAuth
        const rawHash = window.location.hash.slice(1);
        const hash = rawHash === '_=_' ? '' : rawHash;
        if (hash) {
            const params = new URLSearchParams(hash);
            const success = params.get('success');
            const message = params.get('message');
            const error = params.get('error');
            const errorDescription = params.get('error_description');

            if (success === 'true') {
                const needsTesterAccess = params.get('needs_tester_access') === 'true';
                navigate('/meta/connection', {
                    replace: true,
                    state: { oauthSuccess: true, needsTesterAccess },
                });
                return;
            }

            const errorMsg = errorDescription || error || message || 'Erro ao conectar com o Meta.';
            navigate('/meta/connection', {
                replace: true,
                state: { oauthError: errorMsg },
            });
            return;
        }

        // Fluxo com query params: backend redireciona com ?success=true ou ?error=...
        const success = searchParams.get('success');
        const error = searchParams.get('error');
        const errorDescription = searchParams.get('error_description');

        if (success === 'true') {
            const needsTesterAccess = searchParams.get('needs_tester_access') === 'true';
            navigate('/meta/connection', {
                replace: true,
                state: { oauthSuccess: true, needsTesterAccess },
            });
            return;
        }

        if (error) {
            navigate('/meta/connection', {
                replace: true,
                state: { oauthError: errorDescription || error },
            });
            return;
        }

        // Fluxo alternativo: front troca o code por token via API
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        if (!code) {
            navigate('/meta/connection', {
                replace: true,
                state: { oauthError: 'Código de autorização não recebido.' },
            });
            return;
        }

        processOAuthCallback(code, state || undefined)
            .then((data) => {
                const needsTesterAccess = data?.needs_tester_access === true;
                navigate('/meta/connection', {
                    replace: true,
                    state: { oauthSuccess: true, needsTesterAccess },
                });
            })
            .catch((err) => {
                const errMessage =
                    err.response?.data?.error_description ||
                    err.response?.data?.detail ||
                    'Erro ao processar autenticação.';
                navigate('/meta/connection', {
                    replace: true,
                    state: { oauthError: errMessage },
                });
            });
    }, [searchParams, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0f172a] mx-auto"></div>
                <p className="mt-4 text-gray-600 text-lg">Processando autenticação...</p>
            </div>
        </div>
    );
}
